// extracted by mini-css-extract-plugin
export default {"typing-progress":"TypingProgress_typing-progress__5k7nK","typing-dots":"TypingProgress_typing-dots__UuHMn"};